import { render, staticRenderFns } from "./FanovaEntranceDoor.vue?vue&type=template&id=1a54edd8&scoped=true&"
import script from "./FanovaEntranceDoor.vue?vue&type=script&lang=js&"
export * from "./FanovaEntranceDoor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a54edd8",
  null
  
)

export default component.exports